import { useState } from "react";
import { segmentoEhClinica } from "../vocab";
import api from "../api";
import { useTheme } from "../components/Theme";

const SEGMENTOS = ["Clínica de Estética", "Harmonização Facial", "Odontologia", "Clínica Médica", "Fisioterapia e Reabilitação", "Salão de Beleza e Barbearia", "Clínicas e Saúde", "Serviços e Tecnologia", "Engenharia e Construção", "Segurança Eletrônica", "Comércio e Varejo", "Indústria", "Advocacia e Contabilidade", "Agências e Marketing", "Outros"];
const TAMANHOS = ["Só eu", "2 a 3", "4 a 10", "11 a 30", "30+"];
const ORIGENS = ["Google", "Instagram", "WhatsApp", "Indicação", "Site", "Prospecção ativa", "Feiras e eventos"];
const OBJETIVOS = ["Organizar os leads", "Não perder follow-up", "Controlar orçamentos", "Acompanhar a equipe", "Financeiro e comissões"];
const OBJETIVOS_CLINICA = ["Reduzir faltas e desmarcações", "Organizar a agenda", "Controlar pacotes de sessões", "Acompanhar os orçamentos", "Saber de onde vêm os pacientes"];
const CONTROLE_CLINICA = ["Agenda de papel", "Planilha", "Outro sistema", "WhatsApp", "Não controlo"];
const CONTROLE = ["Planilha", "Caderno", "Outro CRM", "WhatsApp", "Não controlo"];
const ETAPAS = [["Seus dados", "Nome, e-mail e senha"], ["Sua empresa", "Segmento e tamanho da equipe"], ["Como você vende", "Para preparar o seu CRM"]];

const soDig = (v) => String(v || "").replace(/\D/g, "");
const mascaraFone = (v) => {
  const d = soDig(v).slice(0, 11);
  if (d.length <= 2) return d ? "(" + d : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
const mascaraCnpj = (v) => {
  const d = soDig(v).slice(0, 14);
  return d.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
};

export default function Signup({ onLogin }) {
  const { theme } = useTheme();
  const COR = theme.orange || "#EE6A1A";
  const cinza = theme.textMuted;
  const [etapa, setEtapa] = useState(1);
  const [f, setF] = useState({ nome: "", email: "", senha: "", empresa: "", telefone: "", cnpj: "", segmento: "", tamanhoEquipe: "", origens: [], objetivos: [], controleAtual: [], querAjuda: false });
  const [verSenha, setVerSenha] = useState(false);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const alterna = (k, v) => setF((x) => ({ ...x, [k]: x[k].includes(v) ? x[k].filter((i) => i !== v) : [...x[k], v] }));

  const avancar1 = async (e) => {
    e.preventDefault(); setErro("");
    if (!f.nome.trim() || !f.email.trim()) return setErro("Preencha seu nome e e-mail.");
    if (f.senha.length < 6) return setErro("A senha precisa ter pelo menos 6 caracteres.");
    setEnviando(true);
    try {
      const r = await api.post("/auth/signup/check-email", { email: f.email });
      if (!r.data.disponivel) return setErro(r.data.message || "Este e-mail já está cadastrado.");
      setEtapa(2);
    } catch (err) { setErro("Não foi possível verificar o e-mail. Tente de novo."); }
    finally { setEnviando(false); }
  };
  const avancar2 = (e) => {
    e.preventDefault(); setErro("");
    if (!f.empresa.trim()) return setErro("Informe o nome da empresa.");
    if (soDig(f.telefone).length < 10) return setErro("Informe um WhatsApp válido com DDD.");
    if (f.cnpj && soDig(f.cnpj).length !== 14) return setErro("CNPJ incompleto. Corrija ou deixe em branco.");
    if (!f.segmento) return setErro("Selecione o segmento da empresa.");
    if (!f.tamanhoEquipe) return setErro("Selecione o tamanho da equipe comercial.");
    setEtapa(3);
  };
  const criar = async (pulou) => {
    setErro(""); setEnviando(true);
    const dados = { ...f, pulou: !!pulou };
    if (pulou) { dados.origens = []; dados.objetivos = []; dados.controleAtual = []; dados.querAjuda = false; }
    try {
      const r = await api.post("/auth/signup", dados);
      localStorage.setItem("crm_token", r.data.token);
      localStorage.setItem("crm_user", JSON.stringify(r.data.user));
      try { localStorage.setItem("crm_empresa", JSON.stringify(r.data.empresa)); } catch (x) {}
      onLogin(r.data.user, r.data.empresa);
    } catch (err) {
      setErro(err.response?.data?.message || "Não foi possível criar a conta. Tente de novo.");
    } finally { setEnviando(false); }
  };

  const foco = (e) => { e.currentTarget.style.borderColor = COR; e.currentTarget.style.boxShadow = `0 0 0 4px ${COR}1F`; };
  const semFoco = (e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; };
  const inp = { width: "100%", height: 50, boxSizing: "border-box", padding: "0 16px", background: theme.bgInput, border: `1.5px solid ${theme.border}`, borderRadius: 12, color: theme.text, fontSize: 16, fontFamily: "inherit", outline: "none", transition: "border-color .15s, box-shadow .15s" };
  const lbl = { fontSize: 14, fontWeight: 600, color: theme.textSub, display: "block", marginBottom: 8 };
  const campo = (rotulo, k, props = {}, extra) => (
    <label style={{ display: "block", flex: 1, minWidth: 0 }}>
      <span style={lbl}>{rotulo}{extra}</span>
      <input value={f[k]} onChange={(e) => set(k, props.mask ? props.mask(e.target.value) : e.target.value)} onFocus={foco} onBlur={semFoco} style={inp} {...props.attrs} />
    </label>
  );
  const chip = (ativo, texto, onClick, largo) => (
    <button key={texto} type="button" onClick={onClick} style={{ flex: largo ? 1 : "0 0 auto", height: largo ? 44 : 40, padding: "0 14px", borderRadius: largo ? 10 : 99, cursor: "pointer", fontFamily: "inherit", fontSize: 14, whiteSpace: "nowrap", boxSizing: "border-box", border: ativo ? `2px solid ${COR}` : `1.5px solid ${theme.border}`, background: ativo ? `${COR}14` : "transparent", color: ativo ? COR : theme.textSub, fontWeight: ativo ? 700 : 500 }}>{texto}</button>
  );
  const grupo = (rotulo, lista, k) => (
    <div>
      <span style={lbl}>{rotulo}</span>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>{lista.map((i) => chip(f[k].includes(i), i, () => alterna(k, i)))}</div>
    </div>
  );
  const botao = (texto, tipo = "submit", onClick) => (
    <button type={tipo} onClick={onClick} disabled={enviando} style={{ width: "100%", height: 54, border: "none", borderRadius: 12, background: COR, color: "#fff", fontWeight: 700, fontSize: 17, cursor: enviando ? "not-allowed" : "pointer", opacity: enviando ? .75 : 1, boxShadow: `0 8px 20px ${COR}47`, fontFamily: "inherit" }}>{texto}</button>
  );
  const linkBtn = (texto, onClick, cor) => (
    <button type="button" onClick={onClick} disabled={enviando} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: "inherit", fontSize: 15, fontWeight: 600, color: cor || theme.textSub }}>{texto}</button>
  );
  const bola = (i) => {
    const feito = i < etapa, atual = i === etapa;
    return (
      <div style={{ width: 32, height: 32, borderRadius: "50%", flexShrink: 0, boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, background: feito ? COR : theme.bgInput, border: feito ? "none" : `${atual ? 2 : 1.5}px solid ${atual ? COR : theme.border}`, color: atual ? COR : cinza }}>
        {feito ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5 9-10" /></svg> : i}
      </div>
    );
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, overflowY: "auto", background: theme.bg, display: "flex", fontFamily: "'Inter',-apple-system,sans-serif" }}>
      <style>{`@media (max-width: 900px){ .cad-painel{ display:none !important; } .cad-cartao{ padding:28px 22px !important; } }`}</style>

      <div className="cad-painel" style={{ flex: "0 0 440px", boxSizing: "border-box", minHeight: "100%", background: `linear-gradient(160deg, ${COR}1F 0%, ${COR}08 60%, transparent 100%)`, borderRight: `1px solid ${theme.border}`, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: 48, gap: 32 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ width: 52, height: 52, borderRadius: 15, background: COR, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 6px 18px ${COR}4D` }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" /></svg>
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 22, color: theme.text }}>Optimus</div>
            <div style={{ fontSize: 14, color: cinza }}>CRM de Vendas</div>
          </div>
        </div>
        <div>
          <h1 style={{ fontSize: 40, fontWeight: 800, color: theme.text, lineHeight: 1.1, letterSpacing: "-.03em", margin: "0 0 14px" }}>
            7 dias grátis para <span style={{ color: COR }}>organizar suas vendas</span>.
          </h1>
          <p style={{ fontSize: 16, color: cinza, lineHeight: 1.6, margin: 0 }}>Sem cartão de crédito. Leva menos de 2 minutos.</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
          {ETAPAS.map(([t, s], idx) => (
            <div key={t} style={{ display: "flex", alignItems: "center", gap: 14 }}>
              {bola(idx + 1)}
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: idx + 1 <= etapa ? theme.text : cinza }}>{t}</div>
                <div style={{ fontSize: 14, color: cinza }}>{s}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
        <div className="cad-cartao" style={{ width: "100%", maxWidth: 520, boxSizing: "border-box", background: theme.bgCard || theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: 20, padding: "40px 44px", boxShadow: "0 20px 50px rgba(30,20,10,.06)", display: "flex", flexDirection: "column", gap: 22 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, color: COR, marginBottom: 8 }}>ETAPA {etapa} DE 3</div>
            <div style={{ height: 6, borderRadius: 99, background: theme.border }}>
              <div style={{ width: `${Math.round((etapa / 3) * 100)}%`, height: 6, borderRadius: 99, background: COR, transition: "width .3s" }} />
            </div>
          </div>

          {etapa === 1 && (
            <form onSubmit={avancar1} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              <div>
                <h2 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 800, color: theme.text, letterSpacing: "-.02em" }}>Crie sua conta</h2>
                <p style={{ margin: 0, fontSize: 15, color: cinza }}>Comece pelos seus dados de acesso.</p>
              </div>
              {campo("Seu nome", "nome", { attrs: { autoFocus: true, autoComplete: "name" } })}
              {campo("E-mail de acesso", "email", { attrs: { type: "email", autoComplete: "email" } })}
              <label style={{ display: "block" }}>
                <span style={lbl}>Senha</span>
                <div style={{ position: "relative" }}>
                  <input type={verSenha ? "text" : "password"} value={f.senha} onChange={(e) => set("senha", e.target.value)} onFocus={foco} onBlur={semFoco} autoComplete="new-password" style={{ ...inp, paddingRight: 48 }} />
                  <button type="button" onClick={() => setVerSenha((v) => !v)} title={verSenha ? "Ocultar senha" : "Mostrar senha"} style={{ position: "absolute", right: 10, top: 13, background: "none", border: "none", padding: 2, cursor: "pointer", color: cinza, display: "flex" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" />{verSenha && <path d="M3 3l18 18" />}</svg>
                  </button>
                </div>
                <span style={{ fontSize: 13, color: cinza, display: "block", marginTop: 6 }}>Mínimo de 6 caracteres</span>
              </label>
              {erro && <Erro texto={erro} />}
              {botao(enviando ? "Verificando..." : "Continuar")}
              <div style={{ fontSize: 15, color: theme.textSub }}>Já tem conta? <a href="/" style={{ color: COR, fontWeight: 700, textDecoration: "none" }}>Entrar</a></div>
            </form>
          )}

          {etapa === 2 && (
            <form onSubmit={avancar2} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <h2 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 800, color: theme.text, letterSpacing: "-.02em" }}>Sua empresa</h2>
                <p style={{ margin: 0, fontSize: 15, color: cinza }}>Com isso já deixamos o CRM com a cara do seu negócio.</p>
              </div>
              {campo("Nome da empresa", "empresa", { attrs: { autoFocus: true, autoComplete: "organization" } })}
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {campo("WhatsApp", "telefone", { mask: mascaraFone, attrs: { inputMode: "tel", placeholder: "(15) 99999-0000", autoComplete: "tel" } })}
                {campo("CNPJ", "cnpj", { mask: mascaraCnpj, attrs: { inputMode: "numeric", placeholder: "00.000.000/0001-00" } }, <span style={{ fontWeight: 400, color: cinza }}> (opcional)</span>)}
              </div>
              <label style={{ display: "block" }}>
                <span style={lbl}>Segmento</span>
                <select value={f.segmento} onChange={(e) => set("segmento", e.target.value)} onFocus={foco} onBlur={semFoco} style={{ ...inp, appearance: "auto", color: f.segmento ? theme.text : cinza }}>
                  <option value="">Selecione o segmento da empresa</option>
                  {SEGMENTOS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </label>
              <div>
                <span style={lbl}>{segmentoEhClinica(f.segmento) ? "Tamanho da equipe" : "Tamanho da equipe comercial"}</span>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{TAMANHOS.map((t) => chip(f.tamanhoEquipe === t, t, () => set("tamanhoEquipe", t), true))}</div>
              </div>
              {erro && <Erro texto={erro} />}
              {botao("Continuar")}
              <div>{linkBtn("← Voltar", () => { setErro(""); setEtapa(1); })}</div>
            </form>
          )}

          {etapa === 3 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div>
                <h2 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 800, color: theme.text, letterSpacing: "-.02em" }}>{segmentoEhClinica(f.segmento) ? "Como funciona sua clínica hoje?" : "Como você vende hoje?"}</h2>
                <p style={{ margin: 0, fontSize: 15, color: cinza }}>Pode marcar mais de uma opção.</p>
              </div>
              {grupo(segmentoEhClinica(f.segmento) ? "De onde vêm seus pacientes?" : "De onde vêm seus clientes?", ORIGENS, "origens")}
              {grupo("O que você quer resolver primeiro?", segmentoEhClinica(f.segmento) ? OBJETIVOS_CLINICA : OBJETIVOS, "objetivos")}
              {grupo(segmentoEhClinica(f.segmento) ? "Hoje você controla a agenda em:" : "Hoje você controla as vendas em:", segmentoEhClinica(f.segmento) ? CONTROLE_CLINICA : CONTROLE, "controleAtual")}
              <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 15, color: theme.textSub, cursor: "pointer" }}>
                <input type="checkbox" checked={f.querAjuda} onChange={(e) => set("querAjuda", e.target.checked)} style={{ width: 20, height: 20, accentColor: COR, margin: 0 }} />
                {segmentoEhClinica(f.segmento) ? "Quero ajuda para configurar a agenda e os procedimentos" : "Quero ajuda de um especialista para configurar"}
              </label>
              {erro && <Erro texto={erro} />}
              {botao(enviando ? "Criando sua conta..." : "Criar minha conta grátis", "button", () => criar(false))}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {linkBtn("← Voltar", () => { setErro(""); setEtapa(2); })}
                {linkBtn("Pular esta etapa", () => criar(true), cinza)}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Erro({ texto }) {
  return <div style={{ background: "#ef444410", border: "1px solid #ef444430", borderRadius: 10, padding: "10px 14px", color: "#ef4444", fontSize: 14 }}>{texto}</div>;
}
